import RatingHoles from './RatingHoles'

export default RatingHoles
